import { Flex, Layout, Menu } from 'antd'
import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

import { ItemType, MenuItemType } from 'antd/es/menu/interface'
import type { MenuProps } from 'antd'
import useUrlSegments from '../utils/hooks/useUrlSegments'

const { Content, Header, Footer } = Layout

interface Props {
  navigationHeader?: NavigationHeaderProps
  children: ReactNode
  header?: ReactNode
}
export default function MainContentLayout({ children, header, navigationHeader }: Props) {
  return (
    <Layout className="main-app-content">
      <Header
        style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
      >
        {navigationHeader && <NavigationHeader {...navigationHeader}/>}
        {header}
        {/* <div>player goes here</div> */}
      </Header>
      <Content>{children}</Content>
    </Layout>
  )
}

interface NavigationHeaderProps {
  navigationPrefix: string
  headerMenu: ItemType<MenuItemType>[]
}
function NavigationHeader({ navigationPrefix, headerMenu }: NavigationHeaderProps) {
  const defaultActiveKeys = useUrlSegments()

  const navigate = useNavigate()
  const handleNavigationMenu: MenuProps['onClick'] = (item) => {
    navigate(navigationPrefix + item.key)
  }
  return (
    <Menu
      style={{flex: 1}}
      theme="dark"
      mode="horizontal"
      selectedKeys={defaultActiveKeys}
      items={headerMenu}
      onClick={handleNavigationMenu}
    />
  )
}
